export default __webpack_public_path__ + "static/media/Helm of Courageous Souls.26920122.jpg";